export { MockWindowRef } from './mock-window-ref';
